/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPatchBannerReqBodyDto
 */
export interface AdminPatchBannerReqBodyDto {
    /**
     * 제목
     * @type {string}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'title'?: string;
    /**
     * 부제목
     * @type {string}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'subtitle'?: string;
    /**
     * 링크
     * @type {string}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'link'?: string;
    /**
     * 링크 타입
     * @type {string}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'linkType'?: AdminPatchBannerReqBodyDtoLinkTypeEnum;
    /**
     * 이미지
     * @type {string}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'image'?: string;
    /**
     * 노출 여부
     * @type {boolean}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'isExposed': boolean;
    /**
     * 이전 배너 uuid
     * @type {string}
     * @memberof AdminPatchBannerReqBodyDto
     */
    'prevBannerUuid': string;
}

export const AdminPatchBannerReqBodyDtoLinkTypeEnum = {
    Self: 'self',
    Blank: 'blank'
} as const;

export type AdminPatchBannerReqBodyDtoLinkTypeEnum = typeof AdminPatchBannerReqBodyDtoLinkTypeEnum[keyof typeof AdminPatchBannerReqBodyDtoLinkTypeEnum];


